<template>
	<div>
		<DashboardHeaderVue
			:title="$route.name"
			:buttonItems="buttonItems"
			@click="handleHeaderClick"
		/>
		<div class="container-fluid mt--6">
			<div class="row">
				<div class="col">
					<LeaderboardTable
						:isLoading="isLoadingLeaderboard"
						:tableData="allLeaderboardItems"
						:tableHeaders="leaderboardTitles"
						@onChanged="leaderboardItemChanged"
						@viewQRClicked="viewQRClicked"
						@viewClicked="viewLeaderboardItemClicked"
						@deleteClicked="deleteLeaderboardItemClicked"
					/>
				</div>
			</div>
			<div class="row">
				<div class="col">
					<MembersTable
						:canFilter="false"
						:showFooter="false"
						:isLoading="isLoadingUsers"
						:tableData="allUsers"
						:tableHeaders="userTitles"
						@viewClicked="viewUserClicked"
					/>
				</div>
			</div>
		</div>
		<NewLeaderboard
			:showModal="showModal"
			:editLeaderboardData="editLeaderboardItemData"
			@close="resetLeaderboardItem()"
			@newLeaderboardItem="onNewLeaderboard"
		/>
		<QuestionModal
			:show="showQuestionModal"
			:question="modalQuestion"
			@close="resetLeaderboardItem()"
			@noClicked="resetLeaderboardItem()"
			@yesClicked="removeLeaderboardItem()"
		/>
	</div>
</template>
<script>
import DashboardHeaderVue from '../HeaderFooterComponents/DashboardHeader.vue';
import {
	getOrganizationDatabase,
	getOrganizationFirestore,
	getOrganizationStorage,
} from '../../../resources/organizationFirebase';
import { mapActions, mapGetters } from 'vuex';
import { ref, get } from '@firebase/database';
import { DashboardChildren } from '../../../routes/routesNames';
import { httpsCallable } from '@firebase/functions';
import { functions } from '../../../resources/firebase';
import { collection, deleteDoc, doc, getDocs, limit, orderBy, query, setDoc, where } from '@firebase/firestore';
import MembersTable from '../../Components/MemberViews/MembersTable.vue';
import LeaderboardTable from '../../Components/LeaderboardViews/LeaderboardTable.vue';
import QuestionModal from '../../../components/Modals/QuestionModal.vue';
import { deleteObject } from 'firebase/storage';
import NewLeaderboard from '../../mainForms/NewLeaderboard.vue';

export default {
	name: 'leaderboard',
	computed: {
		...mapGetters({
			organization: 'getOrganization',
		}),
	},
	components: {
		DashboardHeaderVue,
		MembersTable,
		LeaderboardTable,
		NewLeaderboard,
		QuestionModal
	},
	data() {
		return {
			isLoadingLeaderboard: true,
			isLoadingUsers: true,
			showModal: false,
			showQuestionModal: false,
			modalQuestion: null,
			allUsers: [],
			allLeaderboardItems: [],
			editLeaderboardItemData: null,
			buttonItems: [
            {
					index: 0,
					title: 'New QR Code',
					type: 'primary',
					icon: 'fas fa-plus',
					link: 'google.com',
				},
			],
			leaderboardTitles: [
				{
					key: 'leaderboardTitle',
					label: 'Name',
					sortable: true,
					tdClass: 'align-middle',
				},
				{
					key: 'leaderboardDescription',
					label: 'Description',
					thStyle: { width: '60%' },
					tdClass: 'align-middle',
				},
				{
					key: 'leaderboardPoints',
					label: 'Points',
					sortable: true,
					tdClass: 'align-middle',
				},
				// {
				// 	key: 'scanLimitPerUser',
				// 	label: 'Usage',
				// 	tdClass: 'align-middle',
				// },
				{
					key: 'leaderboardIsActive',
					label: 'Active',
					sortable: true,
					tdClass: 'align-middle',
				},
				{
					key: 'actions',
					label: '',
					tdClass: 'align-middle',
				},
			],
			userTitles: [
				{
					key: 'place',
					label: 'Place',
					thStyle: { width: '5%' },
					tdClass: 'align-middle',
				},
				{
					key: 'nameAndPhoto',
					label: 'Name',
					thStyle: { width: '60%' },
					tdClass: 'align-middle',
					sortByFormatted: (value, key, item) => {
						return item.firstName + item.lastName;
					},
				},
				{
					key: 'username',
					label: 'Username',
					tdClass: 'align-middle',
				},
				{
					key: 'score',
					label: 'Score',
					tdClass: 'align-middle',
				}
			],
		};
	},
	watch: {
		isLoadingLeaderboard(val) {
			this.buttonItems[0].isDisabled = val;
		},
	},
	methods: {
		...mapActions(['showNotification']),
		handleHeaderClick(buttonItem) {
			if (buttonItem.index == 0) {
				this.editLeaderboardItemData = null;
				this.showModal = true;
			}
		},
		resetLeaderboardItem() {
			this.editLeaderboardItemData = null;
			this.showQuestionModal = false;
			this.showModal = false;
		},
		onNewLeaderboard(leaderboardData) {
			var leaderGotData = this.allLeaderboardItems.find(
				(e) => e.leaderboardId == leaderboardData.leaderboardId
			);
			if (leaderGotData) {
				this.getLeaderboardItems();
			} else {
				this.allLeaderboardItems.push(leaderboardData);
			}

			this.showNotification({
				type: 'success',
				message: `${leaderboardData.leaderboardTitle} has been added.`,
			});
		},
		getLeaderboardItems(){
			this.allLeaderboardItems = []
			const firestore = getOrganizationFirestore(this.organization);
			const firestoreRef = collection(firestore, 'leaderboard');
			const queryRef = query(firestoreRef, where('createdVia', "==", "adminPortal"))
			getDocs(queryRef).then((snapshot) => {
				if (!snapshot.empty) {
					snapshot.forEach((item) => {
						var leaderboardItem = item.data();
						if (leaderboardItem.leaderboardId){
							this.allLeaderboardItems.push(leaderboardItem);
						}
					});
					this.isLoadingLeaderboard = false;
				} else {
					this.isLoadingLeaderboard = false;
				}
			});
		},
		getUsers() {
			const firestore = getOrganizationFirestore(this.organization);
			const firestoreRef = collection(firestore, 'users');
			const queryRef = query(firestoreRef, where('isEnrolledInLeaderboard', "==", true), orderBy("leaderboardScore", "desc"), limit(30));
			getDocs(queryRef).then((snapshot) => {
				if (!snapshot.empty) {
					snapshot.forEach((item) => {
						var user = item.data();
						if (user.uid){
							this.allUsers.push(user);
							this.allUsers.sort((a, b) => (a.leaderboardScore < b.leaderboardScore ? 1 : -1));
						} else {
							console.log('No UID for ', item.id)
						}
					});
					this.isLoadingUsers = false;
				}
			});
		},
		viewUserClicked(item) {
			this.$router.push({
				name: DashboardChildren.memberProfile.name,
				query: {
					uid: item.uid,
				},
			});
		},
		viewQRClicked(item){
			setTimeout(() => {
				window.open(item.qrCodePhotoURL, '_blank');
			});
		},
		viewLeaderboardItemClicked(item){
			this.editLeaderboardItemData = item;
			this.showModal = true;
		},
		deleteLeaderboardItemClicked(item) {
			this.editLeaderboardItemData = item;
			this.modalQuestion = `Are you sure you want to remove ${this.editLeaderboardItemData.leaderboardTitle}?`;
			this.showQuestionModal = true;
		},
		leaderboardItemChanged(item){
			const updatedValue = item.value
			const leaderboardItem = item.data
			const firestore = getOrganizationFirestore(this.organization);
			const leaderboardRef = doc(
				firestore,
				`leaderboard/${leaderboardItem.leaderboardId}`
			);
			setDoc(leaderboardRef, { leaderboardIsActive: updatedValue }, { merge: true})
		},
		removeLeaderboardItem() {
			const firestore = getOrganizationFirestore(this.organization);
			const storage = getOrganizationStorage(this.organization);
			const leaderboardRef = doc(
				firestore,
				`leaderboard/${this.editLeaderboardItemData.leaderboardId}`
			);
			const leaderboardStoreRef = ref(
				storage,
				`leaderboard/${this.editLeaderboardItemData.leaderboardId}`
			);

			deleteObject(leaderboardStoreRef)
				.finally(() => {
					deleteDoc(leaderboardRef)
						.then(() => {
							this.getLeaderboardItems();
							this.showNotification({
								type: 'success',
								message: `Item has been deleted.`,
							});
						})
						.catch((error) => {
							this.showNotification({
								type: 'danger',
								message: error.message,
							});
						});
				})
				.catch((error) => {
					console.log(error.message);
				});
		},
	},
	mounted() {
		this.getUsers();
		this.getLeaderboardItems();
	},
};
</script>